import { DeliveryVersion } from '@99designs/graph-utils/types';

export function useLatestVersion(deliveries: DeliveryVersion[]) {
    return Math.max(...deliveries.map((d) => d.versionId));
}
